import { motion } from "framer-motion";
import ContactForm from "@/components/ContactForm";

const fadeUp = {
  hidden: { opacity: 0, y: 16 },
  show: (i = 0) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 0.7, delay: 0.15 + i * 0.12, ease: [0.22, 1, 0.36, 1] },
  }),
};

export const HeroPanel = () => {
  return (
    <div className="max-w-2xl w-full py-16 md:py-24">
      {/* Coming Soon badge */}
      <motion.div
        variants={fadeUp}
        initial="hidden"
        animate="show"
        custom={0}
        className="inline-flex items-center gap-2 border border-white/20 px-3 py-1 mb-10"
        data-testid="coming-soon-badge"
      >
        <span className="h-1 w-1 bg-white/70" />
        <span className="font-mono-plex text-[10px] uppercase tracking-[0.32em] text-white/70">
          Coming Soon
        </span>
      </motion.div>

      {/* Small label */}
      <motion.div
        variants={fadeUp}
        initial="hidden"
        animate="show"
        custom={1}
        className="font-mono-plex text-[11px] uppercase tracking-[0.28em] text-white/40 mb-6"
        data-testid="section-label"
      >
        <span className="text-white/60">01</span>
        <span className="mx-3 text-white/20">—</span>
        <span>Introducing</span>
      </motion.div>

      {/* Headline */}
      <motion.h1
        variants={fadeUp}
        initial="hidden"
        animate="show"
        custom={2}
        className="font-serif-display text-white text-4xl sm:text-5xl md:text-6xl lg:text-7xl leading-[0.98] tracking-tight"
        data-testid="hero-headline"
      >
        Our Local
        <br />
        Stories <span className="text-white/40">LLC</span>
        <span className="block mt-4 text-white/80 text-2xl sm:text-3xl md:text-4xl lg:text-5xl italic font-normal">
          The technical foundation
          <br className="hidden sm:block" /> for modern nomads.
        </span>
      </motion.h1>

      {/* Divider */}
      <motion.div
        variants={fadeUp}
        initial="hidden"
        animate="show"
        custom={3}
        className="mt-10 mb-8 h-px w-16 bg-white/25"
        data-testid="hero-divider"
      />

      {/* Body copy */}
      <motion.p
        variants={fadeUp}
        initial="hidden"
        animate="show"
        custom={4}
        className="font-mono-plex text-sm md:text-[15px] leading-relaxed tracking-wide text-white/55 max-w-xl"
        data-testid="hero-copy"
      >
        We handle the digital utility so you can stay on the road.
        Infrastructure, automation, and AI implementation for the{" "}
        <span className="text-white/80">Ramblin Man II</span> ecosystem.
      </motion.p>

      {/* Contact form */}
      <motion.div
        variants={fadeUp}
        initial="hidden"
        animate="show"
        custom={5}
        className="mt-12"
      >
        <ContactForm />
      </motion.div>
    </div>
  );
};

export default HeroPanel;
